import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken, LOCALE_ID } from '@angular/core';
import { map, Observable } from 'rxjs';

import { EXPORT_API_CONFIG, ExportMetadata } from '../state/export/export.models';

export const EXPORT_CONFIG = new InjectionToken<string>('EXPORT_CONFIG');

@Injectable()
export class ExportService {
  constructor(
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(EXPORT_CONFIG) private exportUrl: string,
    @Inject(EXPORT_API_CONFIG) private serviceUrl: string,
    private httpClient: HttpClient
  ) {}

  download(documentId: string): Observable<Blob> {
    return this.httpClient.get(`${this.serviceUrl}/documents/${documentId}/download`, {
      responseType: 'blob',
    });
  }

  identifyMeta(documentId: string): Observable<ExportMetadata> {
    return this.httpClient
      .get(`${this.serviceUrl}/documents/${documentId}/download`, {
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        map((response) => {
          const contentDisposition = response.headers.get('Content-Disposition');
          const filename = contentDisposition
            ? this.replaceAll(contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim(), /^"|"$/, '')
            : null;
          const contentLength = response.headers.get('Content-Length');

          return {
            name: filename,
            size: contentLength ? <number>(<unknown>contentLength) : 0,
            mime: response.headers.get('Content-Type'),
          };
        })
      );
  }

  link(documentId: string) {
    return `${this.exportUrl}/${this.localeId}/download/${documentId}`;
  }

  private replaceAll(string: string, search: RegExp, replace: string) {
    return string.split(search).join(replace);
  }
}
